import {Plugin} from '@nuxt/types'

declare module 'vue/types/vue' {
  // this.$functionality inside Vue components
  interface Vue {
    $galleryFrameWidth(): number
  }
}

declare module '@nuxt/types' {
  // nuxtContext.app.$functionality inside asyncData, fetch, plugins, middleware, nuxtServerInit
  interface NuxtAppOptions {
    $galleryFrameWidth(): number
  }

  // nuxtContext.$functionality
  interface Context {
    $galleryFrameWidth(): number
  }
}

declare module 'vuex/types/index' {
  // this.$functionality inside Vuex stores
  interface Store<S> {
    $galleryFrameWidth(): number
  }
}

const pluginGalleryFrameWidth: Plugin = ({store}, inject) => {
  inject('galleryFrameWidth', () => {
    switch (store.getters["viewport/media"]) {
      case 'hd': {
        return 768
      }
      case 'sm': {
        return 288
      }
      default: {
        return 576
      }
    }
  })
}

export default pluginGalleryFrameWidth
